import React from 'react';

interface InlineErrorMessageProps {
  message?: string;
}

const InlineErrorMessage: React.FC<InlineErrorMessageProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div role="alert" className="text-red-600 text-sm text-center">
      {message}
    </div>
  );
};

export default InlineErrorMessage;

